import Properties from './Properties';
import { StyledPropertiesLayout } from './styles';

export const PropertiesLayout = StyledPropertiesLayout;

export default Properties;
